import React from "react"
import { useMsal } from "@azure/msal-react"
import { Navigate } from "react-router"
import { b2cPolicies } from "../Auth/AuthConfig"
import Loader from "./Shared/Loader/loader"

const Welcome = () => {

	const context = useMsal()

	if (context.inProgress !== "none") {
		return <Loader />
	}

	if (context.accounts.length === 0) {
		context.instance.loginRedirect(b2cPolicies.authorities.signUpSignIn)
		return <></>
	}

	return <Navigate to="/_Authorize" />
}

export default Welcome
